import { render, staticRenderFns } from "./leaderboard-projected-card.vue?vue&type=template&id=abdb46f2&scoped=true&"
import script from "./leaderboard-projected-card.vue?vue&type=script&lang=js&"
export * from "./leaderboard-projected-card.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard-projected-card.vue?vue&type=style&index=0&id=abdb46f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdb46f2",
  null
  
)

export default component.exports